import { animatePulse } from "@/src/utils/animation.utils";
import { useEffect, useRef } from "react";
import { Animated, View } from "react-native";

/**
 * Placeholder for a FeatureRequestCard while its column loads. Mirrors the
 * card's layout (title, two description lines, avatar) so the column doesn't
 * jump when the real cards land.
 */
export default function FeatureRequestCardSkeleton() {
  const opacity = useRef(new Animated.Value(0.3)).current;

  useEffect(() => {
    const loop = animatePulse(opacity);
    return () => loop.stop();
  }, [opacity]);

  return (
    // The card chrome sits on a plain View: className isn't applied to
    // Animated.View here, which left the bars floating with no card, padding
    // or spacing. Only the pulse (opacity) is animated, on the bars.
    <View
      className="gap-3 p-3 bg-chalk rounded-2xl border border-ash-3"
      testID="feature-request-card-skeleton"
      accessibilityElementsHidden
      importantForAccessibility="no-hide-descendants"
    >
      <Animated.View style={{ opacity, gap: 12 }}>
        <View className="h-4 w-3/4 rounded-md bg-ash-3" />
        <View className="gap-2">
          <View className="h-3 w-full rounded-md bg-ash-3" />
          <View className="h-3 w-2/3 rounded-md bg-ash-3" />
        </View>
        <View className="w-7 h-7 rounded-full bg-ash-3" />
      </Animated.View>
    </View>
  );
}
